import { adminQuery } from '../adminQuery';

interface Params {
  username: string;
  attributes: { Name: string; Value: string }[];
}

export const adminUpdateUserAttributes = async (body: Params) => {
  return await adminQuery.post({
    path: '/updateUserAttributes',
    params: {
      body,
    },
  });
};
